import { render, staticRenderFns } from "./ProfileAboutusEditor.vue?vue&type=template&id=d4160f5e&scoped=true"
import script from "./ProfileAboutusEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileAboutusEditor.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileAboutusEditor.vue?vue&type=style&index=0&id=d4160f5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4160f5e",
  null
  
)

export default component.exports